import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "footer d-flex justify-content-around mt-4 flex-row py-4" }
const _hoisted_2 = { class: "right-side d-flex justify-content-center align-items-center" }
const _hoisted_3 = { class: "me-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VersionButton = _resolveComponent("VersionButton")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("div", { class: "left-side d-flex flex-row" }, [
      _createElementVNode("a", {
        class: "ms-2",
        href: "/PoliticadePrivacidade.pdf",
        target: "_blank"
      }, "Política de privacidade"),
      _createElementVNode("span", { class: "ms-2" }, "|"),
      _createElementVNode("a", {
        class: "link ms-2",
        href: "/PoliticadeCookies.pdf",
        target: "_blank"
      }, "Política de cookies")
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "2010-" + _toDisplayString(_ctx.currentYear) + " © SOLUTI Certificação Digital", 1),
      _createVNode(_component_VersionButton)
    ])
  ]))
}